<template>
  <ButtonBase
    v-bind="$attrs"
    :class="classesButtonStyle"
    :size="size"
    :icon="icon"
    :text="text"
    :type="type"
    :iconTone="iconTone"
    :disabled="disabled"
  >
    <template v-if="$slots.default" #default>
      <slot />
    </template>
  </ButtonBase>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import ButtonBase from "@/elements/UI/button/ButtonBase/ButtonBase.vue";
import style from "./ButtonStyle.module.scss";

export default defineComponent({
  name: "ButtonStyle",
  inheritAttrs: false,
  components: {ButtonBase},
  props: {
    variant: {
      type: String as PropType<ButtonTypeColor>,
      required: true
    },
    size: {
      type: String as PropType<Size>,
      default: "M"
    },
    icon: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    iconTone: {
      type: String as PropType<IconTone>,
      default: "default"
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String as PropType<ButtonTypeClick>,
      default: "button"
    }
  },
  computed: {
    classesButtonStyle(): string[] {
      return [
        style.buttonStyle,
        style[this.variant],
        this.active ? style.active : "",
        this.disabled ? style.disabled : ""
      ];
    }
  }
});
</script>
